import { resolveModelSource } from './resolveModelSource'

// A prefetched model is loaded from Cache Storage as a blob rather than
// downloaded again; the resolver falls back to the network URL whenever no copy
// is held, so this path is identical to a plain load on a miss.
export const loadModelSource = (viewer, urlToLoad, format, onFailure) => (
  resolveModelSource(urlToLoad, format).then(({ source, format: sourceFormat, release }) => (
    viewer.loadModel(source, undefined, sourceFormat)
      // Frees the blob as soon as the viewer is done with it, on both the
      // success and failure paths, and passes the rejection through.
      .finally(release)
      .catch((error) => {
        // Rejections caused by the viewer being torn down mid-load are not
        // real failures.
        if (!viewer.isDisposed) {
          onFailure(error)
        }

        throw error
      })
  ))
)
